import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import ReactTable from 'react-table'
import 'react-table/react-table.css'

export default class ArchiveValues extends React.Component {
  static propTypes = {
    value: PropTypes.array
  }

  render() {
    if (!this.props.value) return null
    const data = this.props.value
    const columns = [
      {Header: 'Código', accessor: 'productCode'},
      {Header: 'Nombre', accessor: 'description'},
      {Header: 'Precio', accessor: 'price'}
    ]
    return (
      <div className={styles.table}>
        <ReactTable data={data} columns={columns} defaultPageSize={10} minRows={3} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Custom/Add/AddProducts/ArchiveValues/index.js